import React, {useRef, useState, useImperativeHandle} from 'react';
import { AutoComplete } from 'antd';

import axios from 'axios';
import {isArray} from "lodash";

const LRU = require("lru-cache")

// use onSelect
// TBD external support for onOutputChange & onSearch
//TBD default and unpacking might be messed up ? when are defaults applied

export const FuncMccTypeAhead = React.forwardRef(function (
    {
        listSize, width, ...props
    }, ref)
{
    const
        [dataSource, setDataSource] = useState([]),
        [value, setValue] = useState(''),
        completeRef = useRef();

    const onSearch = async searchText => {

        setDataSource(await getTerms(searchText, listSize));

        // Generates warning
        //  index.js:1446 Warning: State updates from the useState() and useReducer() Hooks don't support the second callback argument.
        //  To execute a side effect after rendering, declare it in the component body with useEffect().
        // ? but i'm not using a 2nd arg
        // ? Only started getting this after using forward ref
    };

    // Sets up calls that external ref user can access
    // Note requires use of the forwardRef wrapper
    useImperativeHandle(ref, () => ({
        focus: () => {
            completeRef.current.focus();
        },
        clear: () => {
            setValue('');
        }
    }));

    return (
        <AutoComplete
            dataSource={dataSource}
            style={{ width: props.width }}
            onSearch={onSearch}
            onChange={setValue}
            value={value}
            ref={completeRef}
            {...props}
        />
    );
});

export class MccTypeAhead extends React.Component{
    constructor(props) {
        super(props);
        this.state = {dataSource:[],value:''};
        this.onSearch = this.onSearch.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onReturn = this.onReturn.bind(this);
        this.forceReturn = this.forceReturn.bind(this);
        this.completeRef = React.createRef()
    }

    async onSearch(searchText) {
        this.setState({dataSource: await getTerms(searchText, this.props.listSize)});
    };

    onChange(val) {
        this.setState({value:val});
    }

    onSelect(val) {
        this.props.onSelect(val, this.state.value);
    }

    clear() {
        this.setState({value:''});
    }

    focus() {
        this.completeRef.current.focus();
    }

    onKeyDown(event) {
        if(event.key === 'Enter'){
            console.log('enter press here! ');
            this.onReturn();
        }
    }

    onReturn(event) {
        const term = this.state.value.replace(/^\W*-*/,'');
        this.props.onSelect(term, this.state.value);
    }

    forceReturn() {
        if (!this.state.value) {
            return false;
        }
        this.onReturn();
        return true;
    }

    render()
    {
        const {width, listSize, onSelect, ...restProps} = this.props;

        return (
            <AutoComplete
                options={this.state.dataSource}
                style={{width}}
                onSearch={this.onSearch}
                onChange={this.onChange}
                value={this.state.value}
                ref={this.completeRef}
                {...restProps}
                onSelect={this.onSelect}
                onInputKeyDown={this.onKeyDown}
                dropdownStyle={{ maxHeight: 1000 }}
            />
        );
    }
}

MccTypeAhead.defaultProps = {
    listSize: 200,
    width: 200
};


// TBD - ?set up a timed prune
let cache = new LRU({ max: 500, maxAge: 7 * 24 * 60 * 60 });

//TBD if returned list < requested size then could filter instead of new call when extending term
//TBD filter could be applied here on on autocomplete
//TBD Could ask for more results that displaying to increase chance to just filter

async function getTerms(term='',listSize=20) {
    // terms have a lot of corrupt words from PDF extraction e.g. "b each"
    // searching on single letters really hilights this

    term = term.replace(/^\W*(.*\w)\W*$/,'$1')
    term = term.trim();

    if (term.length < 2) {
        return [];
    }

    if (!cache.has(term)) {
        //todo pick up from Client Bridge ?use mcc.call
        try {
            const response = await axios({
                baseURL: 'https://mcc.metrocreativeconnection.com/',
                url: '/austin/typeahead',
                params: {term, listsize: listSize}
            });

            if (!isArray(response.data)) {
                throw new Error('typeahead call bad data: ', response.data)
            }
            cache.set(term, response.data.map(t=>({value:t,label:t})));

        } catch (e) {
            console.error('typeahead call failed: ', e);
            return [];
        }
    }

    return cache.get(term);
}


/*
    let data = cache.get(term);
    return  data !== undefined ? data :
        //todo pick up from Client Bridge ?use mcc.call
        axios({
            baseURL: 'https://mcc.metrocreativeconnection.com/',
            url: '/austin/typeahead',
            params: {term, listSize}
        })
        .then(response=>{

            if (!isArray(response.data)) {
                throw new Error('typeahead call bad data: ',response.data)
            }

            cache.set(term,response.data);
            return response.data;

        }).catch((e)=>{
            console.error('typeahead call failed: ',e);
            return [];
    });
}


 */